import type { ContentPost } from 'api/new-analytics/types';
import NumberUtil from 'utils/number';
import { NOT_AVAILABLE } from '../../performance/utils/getPerformanceMetricDisplay';

export type TopPerformingSortKey = 'engagements' | 'views' | 'reach' | 'likes';

const SORT_KEY_TO_METRIC_KEY: Record<TopPerformingSortKey, string> = {
  engagements: 'engagement',
  views: 'views',
  reach: 'reach',
  likes: 'likes',
};

export function getContentPostTotalEngagement(
  post: ContentPost,
): number | undefined {
  return post.metrics['engagement'];
}

export function getContentPostMetricValue(
  post: ContentPost,
  sortKey: TopPerformingSortKey,
): number | undefined {
  return post.metrics[SORT_KEY_TO_METRIC_KEY[sortKey]];
}

export function formatCompactMetric(n: number | undefined): string {
  if (n == null || !Number.isFinite(n)) {
    return NOT_AVAILABLE;
  }
  return NumberUtil.compact(n);
}
